/* eslint-disable no-undef */
import Features from '../lib/featureFlags';
import { UserPreference } from '../lib/interfaces/userPreference';
import { VuexLocalStorage } from '../lib/vuexLocalStorage';

const storage = new VuexLocalStorage('_USER_PREFERENCE_');

/**
 * TODO: this is for handling the state of existing users after refactoring. It should be safe to remove this after 1st March 2022.
 */
const migratedFromStorage = new VuexLocalStorage('_CLIENT_');

export const state = function (): Partial<UserPreference> {
  return {
    hasClosedCompanyDetailsModal:
      storage.get('hasClosedCompanyDetailsModal') == 'true' ||
      migratedFromStorage.get('hasClosedCompanyDetailsModal') == 'true',
    dontShowTextToJoinSocialPreviewUpdateMsg:
      storage.get('dontShowTextToJoinSocialPreviewUpdateMsg') == 'true',
    shouldRedirectOnSignIn: storage.get('shouldRedirectOnSignIn') == 'true',
    onSignInRedirectTo: storage.get('onSignInRedirectTo')
  };
};

export const getters = {
  shouldShowCompanyDetailsModal: (
    state: UserPreference,
    getters,
    rootState,
    rootGetters
  ) => {
    return (
      !state.hasClosedCompanyDetailsModal &&
      rootGetters['client/requiresContactVerification']
    );
  },

  onSignInRedirectTo: state => {
    return state.onSignInRedirectTo;
  }
};

export const mutations = {
  setHasClosedCompanyDetailsModal(
    state: UserPreference,
    payload: { hasClosedCompanyDetailsModal: string }
  ): void {
    storage.set(state, payload, 'hasClosedCompanyDetailsModal');
  },

  setDontShowTextToJoinSocialPreviewUpdateMsg(
    state: UserPreference,
    payload: { dontShowTextToJoinSocialPreviewUpdateMsg: string }
  ): void {
    storage.set(state, payload, 'dontShowTextToJoinSocialPreviewUpdateMsg');
  },

  setOnSignInRedirect(
    state: UserPreference,
    {
      shouldRedirectOnSignIn,
      onSignInRedirectTo
    }: { shouldRedirectOnSignIn: boolean; onSignInRedirectTo: string }
  ): void {
    storage.set(state, { shouldRedirectOnSignIn }, 'shouldRedirectOnSignIn');
    storage.set(state, { onSignInRedirectTo }, 'onSignInRedirectTo');
  }
};

export const actions = {};
